<template>
	<div class="report">
		<h1>Question Quality Report</h1>
	</div>
</template>

<script>
export default {
	name: "QuestionQuality",
};
</script>
